import React, { useEffect, useState, useContext } from "react";

import { useParams, useNavigate, useLocation /*, Outlet*/ } from 'react-router-dom';

import { strings, translate } from "./../../services/Localization";
import { checkLogin } from "./../../services/Login";
import AppContext from '../../context/AppContext'
import { dialog, dialogDescription } from '../../components/Common';
import { SignInForward } from "../../services/Login";

declare const constants;


import { faArrowRight, faCheckCircle, faTimesCircle, faExclamationTriangle, faAdd, faRefresh  }  from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { IUser } from "src/dassTypes";

import { appBaseUrl, nstBaseUrl, getAppBase, getLabelBasedOnServerType } from '../../utils/consts';

import { GenericDassQuery } from "../../services/BasicDassQueries";

import { toast } from "./../../utils/Toaster";
import { actionIcon } from "./../../utils/filters";

import{ APP_ACC_GROUP_ID_INPUT_VALIDATION, DEFAULT_RECORD_LIMIT }  from "../../components/Common/DataTable/DataTableConsts";


import PageContent from "../PageContent";
import { ActionType, BulkActionType, ColumnType, DataTableOption } from "src/components/Common/DataTable/DataTypes";
import { PageButtonType } from "src/datatypes/datatypes";
import { isMobile } from "react-device-detect";
import { generateDateTimeColumn } from "../../components/Common/columnDefination";


type AccountType = "logins" | "users" | "customers" | "organisations";

interface IAccountProps {
    accountType: AccountType;
}

interface IAccountsStates {
    loggedUser: IUser | null;
    // accountType: string;
    // url: string;
    // available_key: string;
    // showAlertModal: boolean;
    // pageTitle: string;
    // editEntityId: string;            // The entity in this view is a account
    // schemaMethod: "put" | "post" | "";
    // breadCrumbArr: BreadCrumbType[];
    // countLabel: string;
    refresh:boolean;
    isRowDeleted?: boolean;
}


const Accounts:React.FC<IAccountProps> = ( props ) =>  {
    
    const have_license = true;
    const location = useLocation();
    const isNst = (String(location.pathname).indexOf('/nst'));
    
    let baseUrl = appBaseUrl;

    if(isNst) {
        
        baseUrl = nstBaseUrl;
    }

    //const can_list_profile = "can_list_profile";
        
    const AppContextObj = useContext(AppContext);

    let { id, tabname } = useParams();

    
    const navigate = useNavigate();
    const stateInit = { refresh: false, loggedUser: null, isRowDeleted: false };

    const [state, setState] = useState<IAccountsStates>(stateInit);

    const detailPageNav = ( navigate, tab, id, row) => {

        const prevPageUrl = `${getAppBase()}/accounts/${props.accountType}`;

        if(id) {

            navigate(`/app/accounts/${props.accountType}/${id}/${tab}`, {state: {row: row, prevPageUrl:prevPageUrl}})

        }else {

            navigate(`/app/accounts/${props.accountType}/${tab}`, {state: {tab: tab, prevPageUrl:prevPageUrl}})
        }
    }


    

    const getAccountTypeProps = (accountType: AccountType) => {

        if(accountType === 'logins') {
            return {
                accountType: 'logins',
                url: '/uiapi/rest/logins',
                available_key: 'userid',
                pageTitle: strings.NAV_LOGINS_ITEM,
                showAlertModal: false,
                editUserId: null,
                breadCrumbArr: [getLabelBasedOnServerType(strings.NAV_ADMINISTRATIVE, strings.ACCOUNTS, ''), {label:  strings.NAV_LOGINS_LIST_USERS, url:''}],
                countLabel: 'Logins'
            }
        } else if(accountType === 'users') {
            return {
                accountType:'users',
                url:'/uiapi/rest/users',
                available_key:'userid',
                pageTitle: strings.NAV_USERS_ITEM,
                showAlertModal: false,
                editUserId: null,
                breadCrumbArr: [getLabelBasedOnServerType(strings.NAV_ADMINISTRATIVE, strings.ACCOUNTS, ''), {label:  strings.NAV_USERS_LIST_USERS, url:''}]
                ,countLabel: 'Users'
            }

        }else if(accountType === 'customers') {
             return {
                accountType: 'customers',
                url: '/uiapi/rest/customers',
                available_key: 'userid',
                pageTitle: strings.NAV_CUSTOMERS_ITEM,
                showAlertModal: false,
                editUserId: null,
                breadCrumbArr: [getLabelBasedOnServerType(strings.NAV_ADMINISTRATIVE, strings.ACCOUNTS, ''), {label:  strings.NAV_CUSTOMERS_LIST_CUSTOMERS, url:''}]
                ,countLabel: 'Customers'
            }

        }else {
            
            return {
                accountType: 'organisations',
                url: '/uiapi/rest/organisations',
                available_key: 'userid',
                pageTitle: strings.ORGANIZATION_LIST_TITLE,
                showAlertModal: false,
                editUserId: null,
                breadCrumbArr: [getLabelBasedOnServerType(strings.NAV_ADMINISTRATIVE, strings.ACCOUNTS, ''), {label:  strings.NAV_ORGANIZATION_LIST_USERS, url:''}]
                ,countLabel: 'Organisations'
            }
        }
    }


    useEffect(() => {
        if (constants.enable_profiles !== true) {
            window.location.href = appBaseUrl;
        } else {
            //LoggedIn();
            if(checkLogin(AppContextObj.user)) {
                setState(prevState => {return {...prevState, refresh: !prevState.refresh, loggedUser: AppContextObj.user}} )
            }
            }

    },[AppContextObj.user?.userid])




    const addAccount = () => {
        
        
        if(props.accountType === 'logins') {
            tabname = 'add-login';
        } else if(props.accountType === 'users') {
            tabname = 'add-user';
        }else if(props.accountType === 'customers') {
            tabname = 'add-customer';
        }else if(props.accountType === 'organisations') {
            tabname = 'add-organisation';
        }

        detailPageNav(navigate, tabname, '', null);
	};


    const signInForward = async (userid: string) => {
        try {
            
            const user = await SignInForward(userid, baseUrl)
            AppContextObj.updateUser(user);
            
        } catch (e)  {
            console.log(e.message);
            // Show a toast here
        }
	};


	const deleteAccount = async (account: IUser) => {
        const confirmDialogeSettings = {
                title:  strings.DELETE_ACCOUNT_CONFIRMATION,
                description: `${strings.DELETE} "${account.userid}"?`, //"Delete '" + account.userid + "'?"
                actionLabel: strings.ACTION_DELETE,
        };
        if (await dialog(confirmDialogeSettings) === true) {
            try {

                await GenericDassQuery(`/rest/${props.accountType}/${account.userid}`, { method: "DELETE" });
                refreshTable(true);
                toast.success(strings.DELETE_ACCOUNT_SUCCESS);
               
            } catch (e) {
                toast.error(e.message);
            }
        }
	}

	const deleteAccounts = async (selectedRows: any[]) => {

        
         const accounts = selectedRows.map((row) => {
             return row['userid'];
         })


        if (accounts.length === 0) { return; }
        const confirmDialogeSettings = {
            title:  translate(strings.BULK_ACCOUNT_DELETE_CONFIRMATION, {count: accounts.length}) as string,
            description: await dialogDescription(accounts),
            actionLabel: strings.ACTION_DELETE,
        };

        if (await dialog(confirmDialogeSettings) === true) {
            let successCnt = 0;
            for (const account of accounts) {

                try {
                    
                    await GenericDassQuery(`/rest/${props.accountType}/${account}`, { method: "DELETE" });
                    successCnt++;
                } catch (e) {
                    toast.error(e.message);
                }

                refreshTable(true);
               
            }
            if (successCnt > 0) {
                toast.success(translate(strings.BULK_ACCOUNT_DELETE_SUCCESS, {count: successCnt}) as string);
            }
        }

	}

	const updateAccountState = async (account: IUser, account_status: "active" | "suspended" | "disabled") => {

        const msgs = {
            active: {
                title: strings.ACTIVATE_ACCOUNT_CONFIRMATION,
                description: `${strings.ACTIVATE_ACTION} "${account.userid}"?`, 
                actionLabel: strings.ACTIVATE_ACTION,
                success: strings.ACTIVATE_ACCOUNT_SUCCESS
            },
            suspended: {
                title: strings.SUSPEND_ACCOUNT_CONFIRMATION,
                description: `${strings.SUSPEND_ACTION} "${account.userid}"?`, 
                actionLabel: strings.SUSPEND_ACTION,
                success: strings.SUSPEND_ACCOUNT_SUCCESS
            },
            disabled: {
                title: strings.DISABLE_ACCOUNT_CONFIRMATION,
                description: `${strings.DISABLE_ACTION} "${account.userid}"?`,
                actionLabel: strings.DISABLE_ACTION,
                success: strings.DISABLE_ACCOUNT_SUCCESS
            },
        }
        const msg = msgs[account_status];
        const confirmDialogeSettings = {
                title:  msg.title,
                description: msg.description,
                actionLabel: msg.actionLabel,
        };

        if (await dialog(confirmDialogeSettings) === true) {
            try {

                await GenericDassQuery(`/rest/${props.accountType}/${account.userid}`, { method: "PUT", data: {
                    account_status
                }});
                refreshTable();
                toast.success(msg.success);
               
            } catch (e) {
                toast.error(e.message);
            }
        }
	}

    /**
    * Checks if the logged-in user is allowed for certain actions based on  specific conditions.
    * @param user - The user for whom the actions are being checked.
    * @returns `true` if the user is allowed for actions, otherwise `false`.
    */
    const isUserAllowedForActions = (user: IUser) => {
        return !(
            (AppContextObj.user?.org_admin_readonly && !AppContextObj.user?.org_admin  && user?.is_organisation) ||
            (AppContextObj.user?.customer_admin_readonly && !AppContextObj.user?.customer_admin && user?.is_customer) ||
            (AppContextObj.user?.administrator_readonly && !AppContextObj.user?.administrator)
        );
    }

    const getActions = () => {

        const actions: ActionType<IUser>[] = [
            {
                type: "action",
                text: strings.DELETE_ACCOUNT_ACTION,
                render: (row, title) => actionIcon(row.accountid, title, faTrashAlt.iconName),
                action: (user) => deleteAccount(user),
                visible: (user) => user.account_status == 'active' && isUserAllowedForActions(user)
            },
            {
                type: "action",
                text: strings.IMPERSONATE_ACCOUNT_ACTION,
                render: (row, title) => actionIcon(row.accountid, title, faArrowRight.iconName),
                action: (user) => signInForward(user.userid),
                visible: (user) => AppContextObj.user.userid != user.userid  && props.accountType !== 'logins' ? true : false
            },
            {
                type: "action",
                text: strings.SUSPEND_ACCOUNT_ACTION,
                render: (row, title) => actionIcon(row.accountid, title, faExclamationTriangle.iconName),
                action: (user) => updateAccountState(user, "suspended"),
                visible: (user) => have_license && (user.account_status == 'active' || user.account_status == 'disabled') &&isUserAllowedForActions(user)
            },
            {
                type: "action",
                text: strings.DISABLE_ACCOUNT_ACTION,
                render: (row, title) => actionIcon(row.accountid, title, faTimesCircle.iconName),
                action: (user) => updateAccountState(user, "disabled"),
                visible: (user) => have_license && (user.account_status == 'active' || user.account_status == 'suspended') && isUserAllowedForActions(user)
            },
            {
                type: "action",
                text: strings.ACTIVATE_ACCOUNT_ACTION,
                render: (row, title) => actionIcon(row.accountid, title, faCheckCircle.iconName),
                action: (user) => updateAccountState(user, "active"),
                visible: (user) => have_license && (user.account_status == 'suspended' || user.account_status == 'disabled') && isUserAllowedForActions(user)
            },

        ];

        const bulkActions: BulkActionType[] = [{
            type: "action",
            text: strings.DELETE_ACCOUNTS_ACTION,
            render: (row, title) => actionIcon(row.accountid, title, faTrashAlt.iconName),
            icon: faTrashAlt,
            action: deleteAccounts,
            visible: (row, index) => isUserAllowedForActions(row)
        }];

        return { actions, bulkActions };
    }





    const getTableOptions = () => {
	            
        let   tabname = 'edit-user';

        if(props.accountType === 'logins') {
            tabname = 'edit-login';
        } else if(props.accountType === 'users') {
            tabname = 'edit-user';
        }else if(props.accountType === 'customers') {
            tabname = 'edit-customer';
        }else if(props.accountType === 'organisations') {
            tabname = 'edit-organisation';
        }

        const isAdminRender = (user) => {
            if (props.accountType === 'users' && user.administrator) {
                return strings.YES;
            } else if(props.accountType === 'customers' && user.customer_admin) {
                return strings.YES;
            } else if(props.accountType === 'organisations' && user.org_admin) {
                return strings.YES;
            } else if(props.accountType === 'logins' && user.login_admin) {
                return strings.YES;
            } else {
                return strings.NO;
            }
        }
        
        const filterFields = {
            users: "search_administrator",
            customers: "search_customer_admin",
            organisations: "search_org_admin",
            logins: "search_login_admin",
        };

		const columns: ColumnType<IUser>[] = [    
            {
                key: "bulk_action_checkbox",
                type: "bulk_action_checkbox",
                title: "Bulk Action",
                filterable: false,
                cellWidth: 3,
                newCellWidth: "40px",
                customClass: "sticky left-first",
            },
           {
                key: "userid",
                type: "text",
                title: strings.USER_ID,
                filterable: true,
                filterField: 'search_id',
                filterType: 'text',
                newCellWidth: isMobile ? '250px' : "350px",
                dataAlign: "left",
                inputValidation: APP_ACC_GROUP_ID_INPUT_VALIDATION,
                filterParams: {
                    mapper: (x) => x || undefined
                },
                detailLink: true,
                extraClass: 'ow-datatable-overflow-ellipsis',
                detailPageNav: (row) =>  detailPageNav(navigate, tabname, row.userid, row ),
                showCopyLink: true,
                // width: props.accountType !== "logins" ? 370 : 515,
                // minWidth: props.accountType !== "logins" ? 370 : 515,
                width: 100,
                minWidth: 100,
                flex: 2,
                resizable: true,
                customClass: 'left',

            },
            {
                key: "account_status",
                title: strings.STATUS,
                type: "icon_with_tooltip",
                render_icon: (x) => (x.account_status == 'active' ? faCheckCircle : x.account_status == 'disabled' ? faTimesCircle : faExclamationTriangle), 
                render_tooltip: x => x.account_status.charAt(0).toUpperCase() + x.account_status.slice(1),
                filterable: false,
                filterField: '',
                newCellWidth: "70px",
                filterType: '',
                filterParams: {
                    mapper: (x) => x || undefined
                },
                dataAlign:'center',
                width: 110,
                minWidth: 110,
                maxWidth: 110,
                hideDefaultTooltip: true
            },
            {
                key: "administrator",
                title: strings.ADMINISTRATOR,
                type: "boolean",
                filterField: filterFields[props.accountType],
                filterable: true,
                filterType: 'select',
                newCellWidth: "100px",
                filterWidth: "65px",
                filterParams: {
                    options:[
                        {label:strings.YES, value: "true"}
                    ,{label:strings.NO, value: "false"}
                    ]
                },
                render: (user) => isAdminRender(user),
                width: 110,
                minWidth: 110,
                maxWidth: 110,
            },
            {
                key: "can_register",
                title: strings.USER_LIST_REGISTRATION_RIGHTS,
                type: "boolean",
                filterField: 'search_can_register',
                filterable: true,
                newCellWidth: "140px",
                filterWidth: "65px",
                filterType: 'select',
                filterParams: {
                    options:[
                        {label:strings.YES, value: "true"}
                    ,{label:strings.NO, value: "false"}
                    ]
                },
                render: (user) => user.can_register ? strings.YES : strings.NO,
                width: 110,
                minWidth: 110,
                maxWidth: 110,
            },
        ];

        if (props.accountType !== "logins") {
            // No devices on logins.
            columns.push({
                key: "num_devices",
                title: strings.USER_LIST_DEVICE_COUNT,
                type: "text",
                newCellWidth: "100px",
                render: (user) => user.num_devices != null ? user.num_devices + "" : "",
                filterable: false,
                dataAlign: "center",
                width: 150,
                minWidth: 150,
                maxWidth: 150,
             })
        }

        columns.push(generateDateTimeColumn({
            key: "last_login",
            title: strings.LAST_LOGIN,
        }),
        generateDateTimeColumn({
            key: "account_created",
            title: strings.CREATION_TIME,
        }))

        columns.push({
            key: 'action_button',
            type: "action_button",
            title: 'Actions',
            filterable: false,
            cellWidth: 3,
            newCellWidth: "140px",
            customClass: 'sticky right',
        });



        const { actions, bulkActions } = getActions();


        let accountTypeProps = getAccountTypeProps(props.accountType)

        let options: DataTableOption<IUser> = {
            url: accountTypeProps.url,
            query_param:{all:true, get_pages:true, limit:DEFAULT_RECORD_LIMIT, stream:'progress'},
            serial_number:false,
            id_field:'userid',
            oboe_path:'pages.*',
            available_key:accountTypeProps.available_key,            
            columns,
            actions,
            bulkActions,
            agGridAdjustWidthKeys: ['userid'],
            
        }


        return options;
	}

    const refreshTable = (isRowDeleted=false) => {

        setState(prevState => {
            return {...prevState, refresh:!prevState.refresh,isRowDeleted: isRowDeleted}
        })
        
    }

    const getPageButtons = () => {
        let pageButtons: PageButtonType[];
        
        if(props.accountType === 'logins') {
            pageButtons = [
                {
                    title: strings.REFRESH_LIST,
                    action: () => { refreshTable() }
                    ,type: 'button'
                    ,icon: faRefresh
                },
                {
                    title: 'separator',
                    type: 'separator',
                },
                {
                    title: strings.LOGIN,
                    action: () => addAccount(),
                    type: 'button_with_icon',
                    icon: faAdd,
                    visible: () => AppContextObj.user?.login_admin,
                },
            ]

        } else if (props.accountType === 'users') {
            pageButtons = [
                {
                    title: strings.REFRESH_LIST,
                    action: () => { refreshTable() }
                    ,type: 'button'
                    ,icon: faRefresh
                },
                {
                    title: 'separator',
                    type: 'separator',
                },
                {
                    title: strings.USER,
                    action: () => addAccount(),
                    type: 'button_with_icon',
                    icon: faAdd,
                    visible: () => AppContextObj.user?.administrator,
                },
            ]
		    
        }else if(props.accountType === 'customers') {
            pageButtons = [
                {
                    title: strings.REFRESH_LIST,
                    action: () => { refreshTable() }
                    ,type: 'button'
                    ,icon: faRefresh
                },
                {
                    title: 'separator',
                    type: 'separator',
                },
                {
                    title: strings.CUSTOMER,
                    action: () => addAccount(),
                    type: 'button_with_icon',
                    icon: faAdd,
                    visible: () => AppContextObj.user?.customer_admin,
                },
            ]
        }else if(props.accountType === 'organisations') {
            pageButtons = [
                {
                    title: strings.REFRESH_LIST,
                    action: () => { refreshTable() }
                    ,type: 'button'
                    ,icon: faRefresh
                },
                {
                    title: 'separator',
                    type: 'separator',
                },
                {
                    title: strings.ORGANIZATION,
                    action: () => addAccount(),
                    type: 'button_with_icon',
                    icon: faAdd,
                    visible: () => AppContextObj.user?.org_admin,
                },
            ]
        }
        return pageButtons;
    }

    const accountProps = getAccountTypeProps( props.accountType );

    return (<PageContent
        name={props.accountType} 
        id={id} 
        tabname={tabname} 
        breadCrumbArr={accountProps.breadCrumbArr} 
        pageButtons={getPageButtons()} 
        countLabel={`Accounts`} 
        dataTableOption={getTableOptions()} 
        refresh={state.refresh}
        isRowDeleted={state.isRowDeleted}
        childUrl = {`edit-`}
        >
    </PageContent>)

}



export default Accounts;
